import type { AxiosResponseHeaders } from 'axios'

type Error = {
  statusCode: number
  message: string
  headers?: AxiosResponseHeaders
  extra?: unknown
}

class ApiError {
  private _statusCode: number
  private _message: string
  private _headers?: AxiosResponseHeaders
  private _extra?: unknown

  constructor({ statusCode, message, headers, extra }: Error) {
    this._statusCode = statusCode
    this._message = message
    this._headers = headers
    this._extra = extra
  }

  get statusCode(): number {
    return this._statusCode
  }

  get message(): string {
    return this._message
  }

  get headers() {
    return this._headers
  }

  get extra(): unknown {
    return this._extra
  }
}

export default ApiError
